import { FC, ReactNode, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { transport } from '../../../utils/constants';
import { getToken, isRpcError } from '../../../utils/helper';
import IosModal from '../IosModal/IosModal';
import './ControlledInput.scss';
import { ExchangerClient } from '../../../generated/mlmbox/client/exchanger/exchanger.client';
import { Empty } from '../../../generated/google/protobuf/empty';
interface IControlledInput {
    title: string;
    setValue: Function;
    setValue2?: Function;
    value: string;
    typeInput: string;
    close: Function;
    children?: ReactNode;
    placeholder?: string;
    fetch?: Function;
    validate?: Function;
    errorMessgae?: string | null;
    warningMessage?: string | null | undefined;
    errorMessage?: string;
    exchange?: boolean;
    assetId?: number;
}

const ControlledInput: FC<IControlledInput> = ({
    errorMessgae = null,
    validate,
    fetch,
    title,
    setValue,
    close,
    children,
    typeInput,
    value = '',
    placeholder = '',
    assetId,
    exchange,
    setValue2,
}) => {
    const [valueInput, setValueInput] = useState(value);
    const inputRef = useRef<HTMLInputElement>(null);
    const { t } = useTranslation();
    const [warningMessage, setWarningMessage] = useState('');
    const exchangerClient = new ExchangerClient(transport);

    const save = async () => {
        if (validate) {
            const result = await validate(valueInput);
            console.log(result);
            if (result) {
                setValue(valueInput);
                close();
            } else {
                window.Telegram.WebApp.HapticFeedback.notificationOccurred('warning');
            }

            if (errorMessgae) return;
        } else {
            fetch && fetch(valueInput);

            setValue(valueInput);

            close();
        }
    };

    function previewExchange(value: string) {
        exchangerClient
            .all(Empty, { meta: { authorization: getToken() } })
            .then(({ status, response }) => {
                if (status.code === 'OK') {
                    response.items.forEach((item) => {
                        if (item.sourceAssetId === assetId) {
                            if (Number(value) < Number(item.limitSourceAmountMin)) {
                                window.Telegram.WebApp.HapticFeedback.notificationOccurred('warning');
                                setWarningMessage(`${t('min_e')} ${Number(item.limitSourceAmountMin).toLocaleString()}`);

                                setTimeout(() => {
                                    setWarningMessage('');
                                }, 3000);
                            }
                            exchangerClient
                                .preview(
                                    { sourceAmount: value, sourceAssetId: item.sourceAssetId, targetAssetId: item.targetAssetId },
                                    { meta: { authorization: getToken() } }
                                )
                                .then(({ status, response }) => {
                                    if (status.code === 'OK') {
                                        setValue(response.source?.value);
                                        setValue2 && setValue2(response.target?.value);
                                        close();
                                    }
                                })
                                .catch((error) => {
                                    if (isRpcError(error)) {
                                        window.Telegram.WebApp.HapticFeedback.notificationOccurred('warning');
                                        error.message === 'WALLET_BALANCE_NOT_ENOUGH' && setWarningMessage(t('not_e'));

                                        setTimeout(() => {
                                            setWarningMessage('');
                                        }, 3000);
                                    }
                                });
                        }
                    });
                }
            })
            .catch((e) => {
                console.log(e);
                window.Telegram.WebApp.HapticFeedback.notificationOccurred('warning');
            });
    }

    return (
        <IosModal
            title={title}
            cancel={() => close()}
            cancelBtnTitle={t('modals.ios.header.btns.cancel')}
            aprove={async () => (!exchange ? await save() : previewExchange(valueInput))}
            aproveBtnTitle={t('modals.ios.header.btns.save')}>
            <div className="controlled-input">
                <input
                    ref={inputRef}
                    id={errorMessgae ? 'danger' : ''}
                    type={typeInput}
                    value={valueInput}
                    onChange={(e) => setValueInput(e.target.value)}
                    placeholder={placeholder}
                    autoComplete="off"
                />
                {warningMessage && (
                    <div className="message">
                        <div className="message__icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M4.61296 1.44169C6.26599 0.48056 7.09254 0 8.00008 0C8.90762 0 9.73417 0.48056 11.3872 1.44169L11.9463 1.76677C13.5993 2.7279 14.4259 3.20846 14.8796 4C15.3334 4.79154 15.3334 5.75267 15.3334 7.67496V8.32504C15.3334 10.2474 15.3334 11.2085 14.8796 12C14.4259 12.7915 13.5993 13.2721 11.9463 14.2332L11.3872 14.5583C9.73417 15.5194 8.90762 16 8.00008 16C7.09254 16 6.26599 15.5194 4.61296 14.5583L4.05387 14.2332C2.40084 13.2721 1.57432 12.7915 1.12053 12C0.666748 11.2085 0.666748 10.2474 0.666748 8.32504V7.67496C0.666748 5.75267 0.666748 4.79154 1.12053 4C1.57432 3.20846 2.40084 2.7279 4.05387 1.76677L4.61296 1.44169ZM8.8149 11.2C8.8149 11.6418 8.4501 12 8.00008 12C7.55006 12 7.18527 11.6418 7.18527 11.2C7.18527 10.7582 7.55006 10.4 8.00008 10.4C8.4501 10.4 8.8149 10.7582 8.8149 11.2ZM8.00008 3.4C8.33758 3.4 8.61119 3.66863 8.61119 4V8.8C8.61119 9.13136 8.33758 9.4 8.00008 9.4C7.66258 9.4 7.38897 9.13136 7.38897 8.8V4C7.38897 3.66863 7.66258 3.4 8.00008 3.4Z"
                                    fill="rgb(255, 163, 78)"
                                />
                            </svg>
                        </div>
                        <p>{warningMessage}</p>
                    </div>
                )}
                {children && children}
            </div>
        </IosModal>
    );
};

export default ControlledInput;
